<template>
  <b-card class="header-container">
    <div class="left-navbar-container">
      <b-input-group class="input-group-merge">
        <b-input-group-prepend is-text>
          <feather-icon icon="SearchIcon"/>
        </b-input-group-prepend>
        <b-form-input placeholder="Search" v-model="searchInput"/>
      </b-input-group>
    </div>
    <div class="right-navbar-container d-flex justify-content-between align-items-center">
      <!--<locale/>-->
      <div class="dropdown-container d-flex justify-content-between align-items-center">
        <template>
          <div class="user-nav text-right mr-1">
            <p class="user-name font-weight-bolder mb-0 text-secondary">
              {{ userInfo.given_name }} {{ userInfo.family_name }}
            </p>
            <p class="user-status mb-0 text-secondary">
              {{ role }}</p>
          </div>
          <b-avatar button
                    @click="dropdownVisible = !dropdownVisible"
                    size="40"
                    variant="secondary"
                    badge
                    :text="initials"
                    class="badge-minimal"
                    badge-variant="success">
          </b-avatar>
        </template>

        <div id="dropdownItem" class="dropdown-items" v-if="dropdownVisible">
          <div class="dropdown-item" @click="changePasswordModal">
            <feather-icon
                size="16"
                icon="KeyIcon"
                class="mr-50"/>
            <span>Change password</span>
          </div>
          <div class="dropdown-item" @click="logout">
            <feather-icon
                size="16"
                icon="LogOutIcon"
                class="mr-50"/>
            <span>Logout</span>
          </div>
        </div>
      </div>

      <b-modal id="modal-change-password"
               ref="change-password-modal"
               size="lg"
               class="p-3"
               hide-header
               hide-footer
               centered>

        <div class="modal-custom-header d-flex align-items-center justify-content-between">
          <h4>პაროლის შეცვლა</h4>

          <b-button variant="flat-secondary" class="btn-icon mr-1" size="lg" @click="hideModal">
            <feather-icon icon="XIcon"/>
          </b-button>
        </div>

        <b-form class="edit-institution justify-content-between">
          <b-form-group label="მიმდინარე პაროლი *"
                        label-for="old_password">
            <b-form-input id="old_password" v-model="old_password" type="password"
                          placeholder="მიმდინარე პაროლი"/>
          </b-form-group>
          <b-form-group></b-form-group>
          <b-form-group label="ახალი პაროლი *"
                        label-for="password">
            <b-form-input id="password" v-model="password" type="password"
                          placeholder="ახალი პაროლი ინგლისურად"/>
          </b-form-group>
          <b-form-group label="გაიმეორე ახალი პაროლი *"
                        label-for="confirm_password">
            <b-form-input id="confirm_password" v-model="confirm_password" type="password"
                          placeholder="გაიმეორე ახალი პაროლი ინგლისურად"/>
          </b-form-group>
        </b-form>

        <div class="d-flex justify-content-between align-items-center">
          <b-button variant="primary" class="save-changes mb-3" @click="changePassword">
            <feather-icon icon="SaveIcon"
                          class="mr-50"/>
            <span class="align-middle">პაროლის შეცვლა</span>
          </b-button>
        </div>
      </b-modal>
    </div>
  </b-card>
</template>

<script>
import {
  BInputGroup, BInputGroupPrepend, BAvatar, BCard, BFormInput, BForm, BFormGroup, BButton
} from "bootstrap-vue"
import moduleAccounts from "@/store/accounts/moduleAccounts";

export default {
  components: {
    BInputGroup, BInputGroupPrepend, BAvatar, BCard, BFormInput, BForm, BFormGroup, BButton
  },
  name: "HorizontalNavbar",

  data() {
    return {
      userData: {
        firstName: "ივერი",
        lastName: "ღოლიჯაშვილი",
        username: "iveri@leavingstone.com",
        role: "Admin",
        avatar: "",
      },
      dropdownVisible: false,
      searchInput: "",
      old_password: "",
      password: "",
      confirm_password: "",
    }
  },

  mounted() {
    if (!moduleAccounts.isRegistered) {
      this.$store.registerModule("accounts", moduleAccounts);
      moduleAccounts.isRegistered = true
    }
  },

  watch: {
    searchInput: function (newVal) {
      if (newVal.length >= 3) {this.$emit("search", newVal);}
      else if (newVal.length === 0) {this.$emit("search", undefined);}
    }
  },

  computed: {

    userInfo() {
      return JSON.parse(localStorage.getItem("userInfo"));
    },

    initials() {
      let family_name = this.userInfo.family_name ? this.userInfo.family_name[0] : ""
      let given_name = this.userInfo.given_name ? this.userInfo.given_name[0] : ""
      return family_name + given_name
    },

    role() {
      let roles = this.userInfo["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]
      if ( typeof roles === "object") {return roles[0]}
      return roles
    }
  },

  methods: {
    logout() {
      this.dropdownVisible = false;
      localStorage.clear();
      return this.$router.replace("/login");
    },

    changePasswordModal() {
      this.$refs["change-password-modal"].show();
    },

    changePassword() {
      let payload = {
        username: this.phone,
        currentPassword: this.old_password,
        newPassword: this.password,
        confirmNewPassword: this.confirm_password
      };

      return this.$store.dispatch("accounts/changePassword", payload).then(() => {
        alert("პაროლი წარმატებით შეიცვალა");
      }).catch((err) => {
        // alert(err.response.data)
        alert("დაფიქსირდა შეცდომა")
      });
    },

    hideModal() {
      this.$refs["change-password-modal"].hide();
      this.editing = null;
      this.nameGe = "";
      this.nameEng = "";
    },
  }
}

</script>

<style lang="scss">
.header-container .card-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.user-nav p {
  line-height: 1.12;
}

.left-navbar-container {
  width: 40%;

  .input-group-text {
    border: none;
  }

  .form-control {
    border: none;
  }
}

.right-navbar-container {
  li {
    list-style: none;
  }

  .b-nav-dropdown .dropdown-toggle::after {
    display: none;
  }

  .dropdown-items {
    position: absolute;
    background-color: white;
    top: 50px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    right: 0;
    border-radius: 2px;
    cursor: pointer;
    z-index: 1;
  }

  .dropdown-container {
    position: relative;
  }
}


</style>
